import React from "react";
import StrainScanLogo from "./StrainScanLogo";

/**
 * Backwards-compatible wrapper around the new themed StrainScanLogo.
 * Preserves the API used elsewhere (`<Brand size="nav|md|hero" />`).
 */
const CONFIG = {
  nav: { variant: "wordmark", textSize: "sm" },
  sm: { variant: "wordmark", textSize: "sm" },
  md: { variant: "wordmark", textSize: "md" },
  lg: { variant: "stack" },
  hero: { variant: "full" },
};

export default function Brand({ size = "nav", className = "" }) {
  const cfg = CONFIG[size] || CONFIG.nav;
  return <StrainScanLogo variant={cfg.variant} textSize={cfg.textSize} className={className} />;
}
